export default __webpack_public_path__ + "static/media/testimonial01.55f86e8c.png";